var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBell = function SvgBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 20.308 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.024,5.869a8.34,8.34,0,0,1,1.379.258,5.879,5.879,0,0,1,4.481,5.761V19.25l.538.54.449.451H6.061l.449-.451.538-.54V11.887a5.879,5.879,0,0,1,4.481-5.761,10.213,10.213,0,0,1,1.379-.258m.058-4.181a1.764,1.764,0,0,0-1.792,1.8v.84A7.778,7.778,0,0,0,5.2,11.887v6.6l-2.389,2.4v1.2H23.12v-1.2l-2.389-2.4v-6.6a7.778,7.778,0,0,0-5.973-7.56v-.84a1.764,1.764,0,0,0-1.792-1.8Zm2.389,21.6H10.577a2.389,2.389,0,1,0,4.778,0Z",
    transform: "translate(-2.813 -1.688)",
    fill: "currentColor",
    stroke: "none"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "images/bell.ac502178.svg";
export { ForwardRef as ReactComponent };